<template>
    <PullContainer ref="pullContainerRef" :pullDownLoading="false" :pullDownLabel="true">
        <template #container>
            <div class="public_container personnel_wrap" v-loading="loading">
                <div class="returnNavBar">
                    <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true">

                    </ReturnNavBar>
                </div>
                <div class="mobile_personnel_container">
                    <div class="info_card">
                        <div class="top">
                            <div class="img_box">
                                <img
                                    :src="companyInfo.company_logo ? companyInfo.company_logo : defaultCompanyLogo"
                                    alt=""
                                />
                            </div>
                            <div class="top_right">
                                <p class="ellipsis">{{ companyInfo.company_name }}</p>
                                <p>
                                    <span>人数：{{ companyInfo.total_users }}人</span><span>较上月</span
                                    ><i
                                        class="iconfont"
                                        :class="{
                                            'icon-arrow-up': companyInfo.symbol === '+',
                                            'icon-arrow-down': companyInfo.symbol === '-',
                                            arrow_ping: companyInfo.symbol === '',
                                        }"
                                    ></i
                                    ><span>{{ companyInfo.change_users }}人</span>
                                </p>
                            </div>
                        </div>
                        <ul class="bottom">
                            <li v-for="item in operatorBtnList" :key="item.type" @click="handleClickOperator(item)">
                                <img :src="item.iconUrl" alt="" />
                                <p>{{ item.title }}</p>
                            </li>
                        </ul>
                    </div>
                    <p class="sub_title">近期待办</p>
                    <div class="list_container">
                        <ul class="list_tab_wrap">
                            <li
                                v-for="item in tabTypeList"
                                :key="item.type"
                                :class="{ active: tabTypeActive === item.type }"
                                @click="handleClickTab(item)"
                            >
                                <span>{{ item.title }}({{ item.count }})</span>
                            </li>
                        </ul>
                        <div class="list_content mobile_container">
                            <!-- "entry_status": 0,     '邀请入职状态 0=正常 1=待入职', -->
                            <!-- "quit_status": 0,   '离职状态 0=待离职 1=已离职 2=已取消', -->
                            <ul>
                                <li v-for="(item, index) in tableData" :key="index">
                                    <div class="img_box" @click="handleClickDetail(item)">
                                        <img :src="item.avatar ? item.avatar : defaultImg" alt="" />
                                    </div>
                                    <div class="list_item_middle">
                                        <p>
                                            <span class="ellipsis">{{ item.name || '--'}}</span>
                                            <template>
                                                <span class="tag_status tag_status_danger" v-if="item.quit_status == 0"
                                                    >待离职</span
                                                >
                                                <span
                                                    class="tag_status tag_status_warning"
                                                    v-else-if="item.entry_status == 1"
                                                    >待入职</span
                                                >
                                                <span
                                                    class="tag_status tag_status_success"
                                                    v-else-if="item.status == 'pendingConfirm'"
                                                    >待确定</span
                                                >
                                            </template>
                                        </p>
                                        <p>
                                            {{
                                                item.quit_status == 0
                                                    ? "离职"
                                                    : item.status == "pendingConfirm"
                                                    ? "提交"
                                                    : "入职"
                                            }}日期：{{ item.quit_status == 0 ? item.quit_date : item.joined_date }}
                                        </p>
                                    </div>
                                    <div class="list_item_right">
                                        <template>
                                            <van-button
                                                plain
                                                type="danger"
                                                v-if="item.quit_status == 0"
                                                @click="handleClickInfoEdit(item)"
                                                >确定离职</van-button
                                            >
                                            <van-button plain type="info" @click="handleClickInfoEdit(item)" v-else>{{
                                                item.entry_status == 1 ? "确定入职" : "信息确认"
                                            }}</van-button>
                                        </template>
                                    </div>
                                </li>
                            </ul>
                            <div class="no-data_wrap" v-if="!tableData.length">
                                <img
                                    src="https://download.hecoos.com/enlightv/2024-53/3d288f14b93a2bd1cbe2c8e336b9e77d.png"
                                    alt=""
                                />
                                <div>
                                    <p>太棒了！</p>
                                    <p>已处理完全部待办</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <UserSearchSelect
                    :userSelectVisible.sync="userSelectVisible"
                    :userSelectTitle="'选择人员'"
                    @selectUserData="handleSelectUserData"
                    v-if="userSelectVisible"
                />
                <FooterTabbar :tabBarList="tabBarList" :tabBarActive="tabBarActive"></FooterTabbar>
            </div>
        </template>
    </PullContainer>
</template>

<script>
import { GetCompanyDepartmentList, GetUserNum, getMobileUserWorkBench } from "@/api";
import { pagination } from "@/mixins";
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import FooterTabbar from "@/components/mComponents/FooterTabbar.vue";
import UserSearchSelect from "@/components/mComponents/UserSearchSelect.vue";
export default {
    name: "MPersonnelIndex",
    components: { PullContainer, ReturnNavBar, FooterTabbar, UserSearchSelect },
    data() {
        return {
            loading: false,
            defaultImg: require("@/assets/images/default.jpg"),
            defaultCompanyLogo: "https://download.hecoos.com/enlightv/2024-50/6919ee7c360932f1a3d707340824fc36.png",
            operatorBtnList: [
                {
                    type: "add",
                    title: "新增员工",
                    iconUrl: "https://download.hecoos.com/enlightv/2024-49/c6ac03bafa21baf89af1e3a10e034416.png",
                },
                {
                    type: "invit",
                    title: "邀请新员工加入",
                    iconUrl: "https://download.hecoos.com/enlightv/2024-49/3ce541fbf448e2c4f6ee636503e785d4.png",
                },
                {
                    type: "leaveOffice",
                    title: "办理离职",
                    iconUrl: "https://download.hecoos.com/enlightv/2024-49/c68003371d62f5067b89d60d9c67bc7c.png",
                },
            ],
            tabTypeList: [
                { type: "all", title: "全部", count: 0 },
                { type: "entry", title: "待入职", count: 0 },
                { type: "edit", title: "待确定", count: 0 },
                { type: "quit", title: "待离职", count: 0 },
            ],
            tabTypeActive: "all",
            tableData: [],
            pullLoading: false,
            finishedList: false,
            listLoading: false,
            userSelectVisible: false, // 选择人员
            companyInfo: {
                company_name: "",
                company_logo: "",
                total_users: "",
                last_month_users: "",
                change_users: "",
                symbol: "", // 对比后 + 增加 - 是减少 空为不变
            },

            tabBarList: [
                {
                    icon: "icon-shouye",
                    activeIcon: "icon-shouyexuanzhong",
                    routerName: "MPersonnelIndex",
                    title: "首页",
                },
                {
                    icon: "icon-tianjiachengyuan",
                    activeIcon: "icon-tianjiachengyuan-xuanzhong",
                    routerName: "DepartmentPersonnel",
                    title: "人员组织",
                },
                {
                    icon: "icon-lizhi",
                    activeIcon: "icon-lizhi-xuanzhong",
                    routerName: "DimissionManage",
                    title: "离职管理",
                },
            ],
            tabBarActive: 0,
        };
    },
    mixins: [pagination],
    created() {
        this.onPullRefreshList();
        this.getDepartmentList();
        this.getUserNumInfo();
    },
    methods: {
        handleClickOperator({ type }) {
            if (type === "add") {
                this.$router.push({
                    name: "MPersonnelAdd",
                });
            } else if (type === "leaveOffice") {
                // 离职
                this.userSelectVisible = true;
            } else {
                // 邀请新员工加入
                this.$router.push({
                    name: "MPersonnelInvite",
                    query: {
                        type: 1,
                    },
                });
            }
        },
        // 类型切换
        handleClickTab({ type }) {
            this.tabTypeActive = type;
            if (type === "confirm") {
                this.tableData = [];
            } else {
                this.onPullRefreshList();
            }
        },
        // 人员选择数据
        handleSelectUserData(data) {
            this.$router.push({
                name: "MLeaveOffice",
                query: {
                    uid: data.uid,
                },
            });
        },
        // 点击头像
        handleClickDetail(item) {
            this.$router.push({
                name: "MPersonnelDetail",
                query: {
                    uid: item.uid,
                },
            });
        },
        // 点击按钮
        handleClickInfoEdit(item) {
            if (item.quit_status == 0) {
                // 待离职
                this.$router.push({
                    name: "MLeaveOfficeDetail",
                    query: {
                        uid: item.uid,
                        id: item.quit_id,
                    },
                });
            } else {
                this.$router.push({
                    name: "MPersonnelDetail",
                    query: {
                        uid: item.uid,
                        profile_edit: item.entry_status == 1 ? false : true
                    },
                });
            }
        },
        onPullRefreshList() {
            this.loading = true;
            this.pagination.pageNum = 1;
            this.finishedList = false;
            this.tableData = [];
            this.getTableData();
        },
        onLoadList() {
            this.getTableData();
        },
        getTableData() {
            if (this.finishedList) return;
            this.finishedList = true;
            const params = {
                type: this.tabTypeActive,
            };
            getMobileUserWorkBench(params).then((res) => {
                if (res.code === 200) {
                    const data = res.data;
                    this.tableData = data.data || [];
                    this.tabTypeList[0].count = data.all_users || 0;
                    this.tabTypeList[1].count = data.entry_users || 0;
                    this.tabTypeList[2].count = data.edit_users || 0;
                    this.tabTypeList[3].count = data.quit_users || 0;
                    this.loading = false;
                } else {
                    this.loading = false;
                    this.$toast({
                        message: res.message,
                        type: "fail",
                    });
                }
            });
        },
        getStaus(i) {
            let status = "";
            switch (i) {
                case 0:
                    status = "";
                    break;
                case 1:
                    status = "pendingEmployment";
                    break;
                case 2:
                    status = "pendingConfirm";
                    break;
                case 3:
                    status = "pendingLeave";
                    break;
            }
            return status;
        },
        //获取部门列表
        getDepartmentList() {
            this.loading = true;
            GetCompanyDepartmentList().then((res) => {
                if (res.code === 200) {
                    this.companyInfo.company_logo = res.data.company_logo;
                    this.companyInfo.company_name = res.data.company_name;
                } else {
                    this.$toast({
                        message: res.message,
                        type: "fail",
                    });
                }
                this.loading = false;
            });
        },
        // 获取总人数和变动情况
        getUserNumInfo() {
            GetUserNum().then((res) => {
                if (res.code === 200) {
                    const data = res.data || {};
                    this.companyInfo.total_users = data.today_users;
                    this.companyInfo.last_month_users = data.last_month_users;
                    this.companyInfo.change_users = Math.abs(Number(data.today_users) - Number(data.last_month_users));
                    this.companyInfo.symbol = data.symbol;
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.personnel_wrap {
    .mobile_personnel_container {
        background: rgb(247, 248, 250);
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }
    .info_card {
        background: rgba(255, 255, 255, 1);
        .top {
            height: 68px;
            padding: 10px 18px;
            display: flex;
            align-items: center;
            gap: 10px;
            .img_box {
                width: 48px;
                height: 48px;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
                img {
                    width: 44px;
                    height: auto;
                }
            }
            .top_right {
                flex: 1;
                p:nth-child(1) {
                    font-size: 14px;
                    font-weight: 700;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(51, 51, 51, 1);
                }
                p:nth-child(2) {
                    margin-top: 4px;
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(102, 102, 102, 1);
                    span:nth-child(1) {
                        font-size: 14px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 22px;
                        color: rgba(51, 51, 51, 1);
                        margin-right: 8px;
                    }
                    i {
                        font-size: 14px;
                        margin: 0 2px;
                    }
                    .arrow_down,
                    .icon-arrow-down {
                        color: rgba(228, 65, 68, 1);
                    }
                    .arrow_up,
                    .icon-arrow-up {
                        color: rgba(90, 179, 51, 1);
                    }
                    .arrow_ping {
                        display: inline-block;
                        width: 14px;
                        height: 2px;
                        border-radius: 0.3px;
                        background: rgba(240, 170, 50, 1);
                        vertical-align: middle;
                    }
                }
            }
        }
        .bottom {
            height: 78px;
            display: flex;
            li {
                flex: 1;
                padding: 10px 0;
                text-align: center;
                img {
                    width: 32px;
                }
                p {
                    margin-top: 4px;
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(51, 51, 51, 1);
                }
                &:active {
                    background-color: rgba(217, 217, 217, 0.2);
                }
            }
        }
    }
    .sub_title {
        padding: 10px 16px 4px;
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 20.27px;
        color: rgba(51, 51, 51, 1);
    }
    .list_container {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }
    .list_tab_wrap {
        height: 44px;
        background-color: rgba(255, 255, 255, 1);
        border-bottom: 1px solid rgba(247, 248, 250, 1);
        padding: 0 16px;
        display: flex;
        li {
            flex: 1;
            text-align: center;
            line-height: 44px;
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            color: rgba(102, 102, 102, 1);
            position: relative;
            &.active,
            &:active {
                font-size: 14px;
                font-weight: 700;
                color: rgba(41, 144, 255, 1);
                &::after {
                    content: "";
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    height: 2px;
                    opacity: 1;
                    border-radius: 1px 1px, 0px, 0px;
                    background: rgba(57, 151, 242, 1);
                }
            }
        }
    }
    .list_content {
        //height: calc(100% - 44px);
        overflow-y: auto;
        flex: 1;
        ul {
            li {
                padding: 0 16px;
                height: 68px;
                margin-bottom: 1px;
                background-color: rgba(255, 255, 255, 1);
                display: flex;
                align-items: center;
                gap: 8px;
                .img_box {
                    width: 44px;
                    height: 44px;
                    border-radius: 50%;
                    background-color: rgba(204, 204, 204, 1);
                    img {
                        width: 100%;
                        height: 100%;
                        border-radius: 50%;
                        object-fit: cover;
                    }
                }
                .list_item_middle {
                    flex: 1;
                    overflow: hidden;
                    p:nth-child(1) {
                        font-size: 14px;
                        font-weight: 700;
                        letter-spacing: 0px;
                        line-height: 22px;
                        color: rgba(51, 51, 51, 1);
                        margin-bottom: 2px;
                        display: flex;
                        align-items: center;
                        gap: 8px;
                    }
                    .tag_status {
                        flex-shrink: 0;
                        height: 18px;
                        padding: 0 4px;
                        border-radius: 5px;
                        font-size: 14px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 18px;
                        &.tag_status_warning {
                            background-color: rgba(240, 170, 50, 0.15);
                            color: rgba(240, 170, 50, 1);
                        }
                        &.tag_status_success {
                            background-color: rgba(90, 179, 51, 0.15);
                            color: rgba(90, 179, 51, 1);
                        }
                        &.tag_status_danger {
                            background-color: rgba(228, 65, 68, 0.15);
                            color: rgba(228, 65, 68, 1);
                        }
                    }
                }
                .list_item_right {
                    width: 64px;
                    flex-shrink: 0;
                    .van-button {
                        width: 64px;
                        height: 24px;
                        padding: 0;
                        font-size: 12px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        border-radius: 4px;
                    }
                    .van-button--info {
                        color: rgba(41, 144, 240, 1);
                        border-color: rgba(41, 144, 240, 1);
                        &:active {
                            color: rgba(34, 121, 214, 1);
                            border-color: rgba(34, 121, 214, 1);
                            &::before {
                                background-color: #ffffff;
                            }
                        }
                    }
                    .van-button--danger {
                        color: rgba(228, 65, 68, 1);
                        border-color: rgba(228, 65, 68, 1);
                        &:active {
                            color: rgba(182, 52, 54, 1);
                            border-color: rgba(182, 52, 54, 1);
                        }
                    }
                }
            }
        }
    }
    .no-data_wrap {
        padding: 130px 0 0;
        text-align: center;
        img {
            width: 69px;
            height: auto;
        }
        p {
            margin-top: 2px;
            text-align: center;
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 18px;
            color: rgba(41, 144, 255, 0.6);
        }
    }
}
</style>
